import "core-js/modules/es.function.name.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { SidebarToken, Status } from "./styles";
import { capitalize } from '@applyboard/ui-utils';
var showIcon = function showIcon(status) {
  switch (status.status) {
    case 'accepted':
    case 'rejected':
    case 'waitlisted':
    case 'program_closed':
      return false;
    default:
      return true;
  }
};
var getLabelForStatus = function getLabelForStatus(status) {
  if (status === 'program_closed') {
    return 'Program Closed';
  }
  return capitalize(status);
};
var StatusWidget = function StatusWidget(_ref) {
  var status = _ref.status;
  return /*#__PURE__*/React.createElement(SidebarToken, {
    key: status.key,
    status: status.status
  }, showIcon(status) && /*#__PURE__*/React.createElement(FontAwesome, {
    name: status.name
  }), /*#__PURE__*/React.createElement(Status, null, getLabelForStatus(status.status)));
};
export default StatusWidget;